import React from 'react'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import {Container} from '@mui/material'

import {Home, Register, Login} from './Pages'
import {Navbar} from './components'

function App() {
  


  return (
    <BrowserRouter >
   <Container maxWidth='lg' sx={{width: '100vw'}}>
      <Navbar />

       <Container>
         <Routes>
           <Route name='Login' path='/'  element={<Home />}  />
         <Route name='Home' path='/login' element={<Login />} />
          
           <Route name='Register' path='/register' element={<Register />} />
         </Routes>
       </Container>
   </Container>
   </BrowserRouter>
  );
}

export default App;
